import { Controller } from "@hotwired/stimulus"

// "Print / Save as PDF": the browser's print dialog, from a button (the
// content security policy allows no inline handlers).
export default class extends Controller {
  print() {
    window.print()
  }
}
